export default {
  approvedSince: {
    id: 'seller_page_main_seller_info_approved_since',
    defaultMessage:
      'Approved seller with {rating, number}/{maxRating, number} Stars rating',
  },
  trusted: {
    id: 'seller_page_main_seller_info_trusted',
    defaultMessage: 'Trusted on Back Market for {years, html}',
  },
  years: {
    id: 'seller_page_main_seller_info_years',
    defaultMessage: `{years, plural,
      one {# year}
      other {# years}
    }`,
  },
  basedIn: {
    id: 'seller_page_main_seller_info_based_in',
    defaultMessage: 'Based in {country}',
  },
} as const
